module.exports = __webpack_public_path__ + "img/flower_leaf_25.786e5c17.png";